<template>
	<v-container>
			<div class="base-page">
				<logo-with-title :title="$t('login')" />
				<v-row v-if="project && project.subject" style="margin-top: -3%" align="start" class="project-name">
					<v-col class="project-name--col d-flex justify-center">
						<div class="px-3 text-center d-flex align-center justify-center">
							{{ project.subject }}
						</div>
					</v-col>
				</v-row>
				<login-form :loading="loading" :error="error" @submit="handleSubmit" @register="gotoRegister" />
				<lang-select />
			</div>
	</v-container>
</template>

<script>
import { types } from "src/store/modules/Auth.module";
import ProjectModule from "src/store/modules/Project.module";
import LangSelect from "@/components/LangSelect";
import afterLogin from "../../hooks/AfterLogin";
import LoginForm from "./LoginForm";
import LogoWithTitle from "@/components/LogoWithTitle";

export default {
	components: {
		LogoWithTitle,
		LangSelect,
		LoginForm
	},
	props: {
		admin: {
			type: Boolean
		}
	},
	data: () => ({
		disabled: false,
		showEduLogin: false,
		form: {
			email: "",
			password: ""
		},
		error: "",
		loading: false,
	}),
	computed: {
		project() {
			return this.$store.state.ProjectModule.project;
		},
		csrf() {
			return document.querySelector("meta[name=csrf-token]").getAttribute("content");
		}
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(ProjectModule.types.GET, id);
		}

	},
	methods: {
		async handleSubmit(params) {
			this.loading = true;
			this.error = "";
			this.disabled = true;
			try {
				const user = await this.$store.dispatch(types.LOGIN, params.form);
				console.log("after submit");
				afterLogin(user, this.project);
			} catch (error) {
				console.log("error!!!");
				console.error(error)
				if (error.response) {
					if (error.response.status === 420) {
						return this.$router.push({ name: "user-profile-force", query: { p: this.$route.query.p } });
					}
					this.error = error.response.data.message;
				}
				this.showError = true;
				this.loading = false;
			}
		},
		gotoRegister() {
			let query = "";
			if (this.project?.id)
				query = `?p=${this.project?.id}`;
			this.$router.push({ path: `/signup${query}` });
		},
		gotoForgotPassword() {
			this.$router.push({ path: "forgot-password" });
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	.project-name {
		&--col {
			padding: 0;

			div {
				height: 40px;
				width: 220px;
				background: #4595cc 0 0 no-repeat padding-box;
				border-radius: 0 0 20px 20px;
				opacity: 1;
			}
		}
	}
}
</style>
